// Imágenes que el backend acepta para íconos y logos (PNG, JPG o SVG, máx. 1 MB).
export const MAX_IMAGE_BYTES = 1024 * 1024;
const IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];

export default class FileUtils {
  static getBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result.split('base64,')[1]);
      };
      fileReader.onerror = error => {
        reject(error);
      };
    });
  }

  // El navegador puede no informar el MIME de un SVG; se acepta también por extensión.
  static isAllowedImage(file) {
    return IMAGE_MIME_TYPES.includes(file.type) || /\.svg$/i.test(file.name || '');
  }

  // Último segmento de una URL, para mostrar el archivo actual como placeholder.
  static fileNameFromUrl(url) {
    const lastSegment = (url || '').split('/').pop();
    try {
      return decodeURIComponent(lastSegment);
    } catch {
      // URL con escapes inválidos: se muestra tal cual en vez de romper el formulario.
      return lastSegment;
    }
  }
}
